module.exports = __webpack_public_path__ + "static/img/dynamicr.3073025.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicr.png
// module id = hRg/
// module chunks = 45